/*! RZC – Pokémon (base One Piece, scopé & isolé) */
(function () {

  if (window.__RZC_PKM_COLLECTION_V2__) return;
  window.__RZC_PKM_COLLECTION_V2__ = true;

  const root = document.getElementById("rzc-pkm");
  if (!root) return; 

  const seriesHandle = root.dataset.lzSeriesHandle || "";
  const universe = root.dataset.lzUniverse || "pkm";
  const customerEmail = root.dataset.lzCustomerEmail || "";
  const loginUrl = root.dataset.lzLoginUrl || "/account/login";
  const normalizedEmail = (customerEmail || "").trim().toLowerCase();
  const isLoggedIn = !!normalizedEmail;
 
  // =======================================================
  // AJAX ADD TO CART (CRITIQUE FIX)
  // =======================================================
  root.addEventListener('submit', async (e) => {
    const form = e.target.closest('.rzc-var-form');
    if (!form) return;
    e.preventDefault();

    const btn = form.querySelector('.rzc-var-btn');
    if (btn && btn.classList.contains('is-disabled')) {
        showToast("❌ Non Disponible", true);
        return;
    }

    if(btn) btn.classList.add('is-loading');

    const formData = new FormData(form);
    const items = [{
        id: formData.get('id'),
        quantity: 1
    }];

    try {
        await addBatch(items);
        showToast("✅ Ajouté au panier");
        await refreshCartCount();
    } catch (err) {
        showToast("Erreur d'ajout", true);
        console.error(err);
    } finally {
        if(btn) btn.classList.remove('is-loading');
    }
  });

  // =======================================================
  // STATE + PERSISTENCE via Edge Function lz-api
  // (plus d'accès direct à Supabase — voir assets/lz-api-client.js)
  // =======================================================
  let lzOwnedFromSupabase = new Set();
  let lzOwnedVariantsFromSupabase = new Set();

  async function loadOwnedFromSupabase() {
    if (!normalizedEmail) {
      updateAllStats();
      return;
    }
    if (!window.lzApi) {
      console.warn("[RZC PKM] window.lzApi non disponible — tracking désactivé.");
      updateAllStats();
      return;
    }

    try {
      const res = await window.lzApi.collectionLoad({ email: normalizedEmail, universe });
      if (!res.ok) {
        console.error("[RZC PKM] collectionLoad error:", res);
        updateAllStats();
        return;
      }

      lzOwnedFromSupabase         = new Set(res.data.products || []);
      lzOwnedVariantsFromSupabase = new Set(res.data.variants || []);

      root.querySelectorAll(".rzc-item.lz-collection-item").forEach(item => {
        const pid = String(item.dataset.productId || "");
        if (lzOwnedFromSupabase.has(pid)) {
          item.classList.add("lz-owned");
          const pt = getPrimaryVariantToggle(item);
          if (pt) { pt.dataset.owned = "true"; pt.textContent = "✅"; syncPrimaryMainVariantButton(item, true); }
        }
      });
      root.querySelectorAll(".lz-var-toggle-owned").forEach(btn => {
        if (lzOwnedVariantsFromSupabase.has(String(btn.dataset.variantId))) {
          btn.dataset.owned = "true"; btn.textContent = "✅";
          const form = btn.closest(".rzc-var-form");
          if (form) form.querySelector(".rzc-var-btn")?.classList.add("lz-var-owned");
        }
      });
      updateAllStats();
      syncFabTogglesFromPanel();
    } catch (e) {
      console.error("[RZC PKM] loadOwnedFromSupabase exception:", e);
      updateAllStats();
    }
  }

  const bootOwned = async () => {
    // ✅ révèle l'UI immédiatement (plus de latence visuelle)
    root.classList.add("is-ready");

    try {
      await loadOwnedFromSupabase();

      if (isLoggedIn) {
        updateAllStats();
      }
    } catch (e) {
      console.error(e);
    }
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", bootOwned);
  } else {
    bootOwned();
  }

  // =======================================================
  // PERSISTENCE
  // =======================================================
  async function persistOwnedState(pid, owned, title) {
    if (!normalizedEmail || !window.lzApi) return;
    const res = await window.lzApi.toggleProduct({
      email: normalizedEmail,
      universe,
      productId: String(pid),
      owned,
      seriesHandle,
      productTitle: title || "",
    });
    if (!res.ok) console.error("[RZC PKM] toggleProduct error:", res);
  }

  async function persistVariantOwnedState(vid, owned, pid, ptitle, kind) {
    if (!normalizedEmail || !window.lzApi) return;
    // Note : au passage on fixe l'ancien bug où le DELETE utilisait
    // customerEmail non normalisé au lieu de normalizedEmail.
    // L'Edge Function normalise l'email côté serveur de toute façon.
    const res = await window.lzApi.toggleVariant({
      email: normalizedEmail,
      universe,
      variantId: String(vid),
      owned,
      variantKind: kind || "",
      seriesHandle,
      productTitle: ptitle || "",
    });
    if (!res.ok) console.error("[RZC PKM] toggleVariant error:", res);
  }

  async function syncSeriesProgressToSupabase(g, r) {
    if (!normalizedEmail || !seriesHandle || !window.lzApi) return;
    const res = await window.lzApi.syncProgress({
      email: normalizedEmail,
      universe,
      seriesHandle,
      seriesTitle: document.title,
      totalCards: g.total,
      ownedCards: g.owned,
      totalReverseCards: r.total,
      ownedReverseCards: r.owned,
    });
    if (!res.ok) console.error("[RZC PKM] syncProgress error:", res);
  }

  // =======================================================
  // HELPERS
  // =======================================================
  function showToast(text, isError) {
    let el = root.querySelector(".rzc-toast");
    if (!el) { el = document.createElement("div"); el.className = "rzc-toast"; root.appendChild(el); }
    el.classList.toggle("is-error", !!isError); el.textContent = text; el.style.display = "block";
    clearTimeout(showToast.timer); showToast.timer = setTimeout(() => { el.style.display = "none"; }, 1800);
  }
  async function refreshCartCount() { try { const r=await fetch("/cart.js"); const c=await r.json(); document.querySelectorAll("[data-cart-count], .cart-count-bubble").forEach(e=>e.textContent=c.item_count); } catch(e){} }
  async function addBatch(items) {
    const res = await fetch("/cart/add.js", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ items }) });
    if (!res.ok) throw new Error("Erreur");
  }

  const variantToItem = new Map();
  const variantPrices = new Map();
  let allItems = Array.from(root.querySelectorAll(".rzc-item"));

  function indexItems(items) {
    items.forEach(li => {
      li.querySelectorAll(".rzc-var-form").forEach(f => {
        const id = parseInt(f.querySelector('input[name="id"]')?.value, 10);
        if (id) {
          const p = f.querySelector(".rzc-var-price")?.textContent
            .replace(/[^\d,\.]/g, "")
            .replace(",", ".");
          if (p) variantPrices.set(id, parseFloat(p));
          variantToItem.set(id, li);
        }
      });
    });
  }

  // index initial page 1
  indexItems(allItems);

    // =======================================================
  // PRECHARGEMENT MULTI-PAGES (ajoute toutes les pages a la suite)
  // Permet aux filtres de couvrir TOUTES les cartes (>250)
  // =======================================================
  const gridEl = root.querySelector(".rzc-grid");
  let nextUrl = root.querySelector("#rzc-next-page")?.dataset.nextUrl || null;
  let isLoadingNext = false;

  // Mapping handle -> URL image, enrichi a chaque page chargee
  const imgUrlByType = { rarete: {}, type: {}, fonction: {}, stade: {}, regulation: {} };

  async function preloadNextPages() {
    if (!nextUrl || isLoadingNext || !gridEl) return;
    isLoadingNext = true;
    let guard = 0;

    try {
      while (nextUrl && guard < 20) {
        guard++;
        const res = await fetch(nextUrl, { credentials: "same-origin" });
        if (!res.ok) break;

        const html = await res.text();
        const doc = new DOMParser().parseFromString(html, "text/html");

        const newItems = Array.from(doc.querySelectorAll("#rzc-pkm .rzc-item"));
        newItems.forEach(li => gridEl.appendChild(li));
        indexItems(newItems);

        // Extrait les URLs images des pills filtre du panel de cette page (page 2+)
        doc.querySelectorAll("#rzc-pkm .lz-filter-pill--img").forEach((pill) => {
          const t = pill.dataset.filterType;
          const v = pill.dataset.filterValue;
          const img = pill.querySelector("img");
          if (t && v && img && img.src && imgUrlByType[t]) {
            imgUrlByType[t][v] = img.src;
          }
        });

        nextUrl = doc.querySelector("#rzc-next-page")?.dataset.nextUrl || null;
      }

      // refresh des listes globales
      allItems = Array.from(root.querySelectorAll(".rzc-item"));
      collectionItems = Array.from(root.querySelectorAll(".lz-collection-item"));

      // recalc UI / stats / pills avec tout le monde
      updateAllStats();
      // ajoute les pills filtre manquantes pour les nouveaux handles
      refreshFilterPills();
      // applique les filtres actifs (URL) sur les nouveaux items
      restoreFiltersFromUrl();
      applyFilters();

    } catch (e) {
      console.error("[RZC PKM] preload next pages erreur:", e);
      nextUrl = null;
    } finally {
      isLoadingNext = false;
    }
  }

  const FILTER_LABELS = {
    rarete: { commune: "Commune", "peu-commune": "Peu Commune", rare: "Rare", "holo-rare": "Holo Rare", "double-rare": "Double Rare", "ultra-rare": "Ultra Rare", "illustration-rare": "Illustration Rare", "illustration-speciale-rare": "Illustration Spéciale Rare", "hyper-rare": "Hyper Rare", "shiny-rare": "Shiny Rare", "shiny-ultra-rare": "Shiny Ultra Rare", "high-tech-rare": "High-Tech Rare", "mega-attaque-rare": "Méga Attaque Rare", "mega-hyper-rare": "Mega Hyper Rare", "rare-noir-blanc": "BWR", promo: "Promo" },
    type: { plante: "Plante", feu: "Feu", eau: "Eau", electrique: "Électrique", psy: "Psy", combat: "Combat", obscurite: "Obscurité", metal: "Metal", fee: "Fée", dragon: "Dragon", incolore: "Incolore", vol: "Vol" },
    fonction: { pokemon: "Pokemon", "dresseur-objet": "Dresseur", "dresseur-supporter": "Supporter", "dresseur-stade": "Stade", "dresseur-outil-pokemon": "Outil", "energie-base": "Énergie", "energie-speciale": "Énergie Spéciale" },
    stade: { base: "De Base", "niveau-1": "Niveau 1", "niveau-2": "Niveau 2", ex: "Pokemon-ex", v: "Pokemon V", vmax: "Pokemon VMAX", vstar: "Pokemon VSTAR", gx: "Pokemon-GX", "tag-team": "Tag Team GX", "mega-evolution": "Méga Évolution" },
    regulation: {}
  };
  const FILTER_TITLE_MAP = { rarete: "Rareté", type: "Type", stade: "Stade", fonction: "Fonction", regulation: "Régulation" };
  // Ordre canonique pour re-tri des pills apres ajout (sinon appendChild les met en fin)
  const FILTER_ORDER = {
    rarete: ["commune","peu-commune","rare","holo-rare","double-rare","illustration-rare","ultra-rare","mega-attaque-rare","illustration-speciale-rare","hyper-rare","mega-hyper-rare","shiny-rare","shiny-ultra-rare","high-tech-rare","rare-noir-blanc","promo"],
    type: ["plante","feu","eau","electrique","psy","combat","obscurite","metal","fee","dragon","incolore","vol"],
    stade: ["base","niveau-1","niveau-2","ex","v","vmax","vstar","gx","tag-team","mega-evolution"],
    fonction: ["pokemon","dresseur-objet","dresseur-supporter","dresseur-stade","dresseur-outil-pokemon","energie-base","energie-speciale"],
    regulation: ["d","e","f","g","h","i","j"]
  };

  function reorderPills(pillsContainer, ft) {
    const order = FILTER_ORDER[ft];
    if (!order || !pillsContainer) return;
    const pills = Array.from(pillsContainer.querySelectorAll(".lz-filter-pill"));
    pills.sort((a, b) => {
      const ai = order.indexOf(a.dataset.filterValue);
      const bi = order.indexOf(b.dataset.filterValue);
      const af = ai === -1 ? Infinity : ai;
      const bf = bi === -1 ? Infinity : bi;
      return af - bf;
    });
    pills.forEach((pill) => pillsContainer.appendChild(pill));
  }

  function refreshFilterPills() {
    const panel = document.getElementById("lz-filter-panel");
    if (!panel) return;

    ["rarete", "type", "fonction", "stade", "regulation"].forEach((ft) => {
      const existing = new Set();
      panel.querySelectorAll('.lz-filter-pill[data-filter-type="' + ft + '"]').forEach((p) => existing.add(p.dataset.filterValue));

      const found = new Set();
      allItems.forEach((item) => {
        const val = (item.dataset[ft] || "").toLowerCase();
        if (!val) return;
        val.split(",").forEach((v) => { if (v.trim()) found.add(v.trim()); });
      });

      const missing = [...found].filter((v) => !existing.has(v));

      // trouve la section cible par son titre (texte du summary ou title div)
      let targetSection = null;
      panel.querySelectorAll(".lz-filter-title").forEach((t) => {
        const txt = (t.textContent || "").trim().split("\n")[0].trim();
        if (txt === FILTER_TITLE_MAP[ft]) targetSection = t.closest(".lz-filter-section, details.lz-filter-section--collapsible");
      });

      // pas de section ET pas de manquantes => skip
      if (!targetSection && !missing.length) return;

      if (!targetSection && missing.length) {
        targetSection = document.createElement("div");
        targetSection.className = "lz-filter-section";
        targetSection.innerHTML = '<div class="lz-filter-title">' + FILTER_TITLE_MAP[ft] + '</div><div class="lz-filter-pills"></div>';
        const resetBtn = panel.querySelector("#lz-filter-reset");
        if (resetBtn) panel.insertBefore(targetSection, resetBtn);
        else panel.appendChild(targetSection);
      }

      const pillsContainer = targetSection.querySelector(".lz-filter-pills");
      if (!pillsContainer) return;

      missing.sort().forEach((val) => {
        const label = (FILTER_LABELS[ft] && FILTER_LABELS[ft][val]) || val.replace(/-/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
        const imgUrl = (imgUrlByType[ft] || {})[val];
        const btn = document.createElement("button");
        btn.type = "button";
        btn.dataset.filterType = ft;
        btn.dataset.filterValue = val;
        btn.setAttribute("aria-pressed", "false");
        btn.setAttribute("title", label);
        btn.setAttribute("aria-label", label);
        if (imgUrl) {
          btn.className = "lz-filter-pill lz-filter-pill--img";
          const img = document.createElement("img");
          img.src = imgUrl;
          img.alt = label;
          img.loading = "lazy";
          img.decoding = "async";
          btn.appendChild(img);
        } else {
          btn.className = "lz-filter-pill";
          btn.textContent = label;
        }
        btn.addEventListener("click", () => {
          const pressed = btn.getAttribute("aria-pressed") === "true";
          btn.setAttribute("aria-pressed", pressed ? "false" : "true");
          applyFilters();
          syncFiltersToUrl();
        });
        pillsContainer.appendChild(btn);
      });

      // Re-trie selon l'ordre canonique pour eviter que les pills ajoutees
      // apres preload se retrouvent en fin de liste
      reorderPills(pillsContainer, ft);
    });
  }

  // lance le préchargement tranquille après le rendu
  if (nextUrl) {
    const idle = window.requestIdleCallback || (fn => setTimeout(fn, 300));
    idle(() => preloadNextPages());
  }

  let collectionItems = Array.from(root.querySelectorAll(".lz-collection-item"));
  let filterPill = null;

  function getVariantKindForId(li, id) { const tgl = li.querySelector(`.lz-var-toggle-owned[data-variant-id="${id}"]`); return tgl?.dataset.kind || "normal"; }
  function getPrimaryVariantToggle(li) { return li.querySelector('.lz-var-toggle-owned:not([data-kind="reverse"])') || li.querySelector(".lz-var-toggle-owned"); }
  function syncPrimaryMainVariantButton(li, owned) { const tgl = getPrimaryVariantToggle(li); if(tgl) { const vid=tgl.dataset.variantId; const btn=li.querySelector(`.rzc-var-form input[value="${vid}"]`)?.closest("form")?.querySelector(".rzc-var-btn"); if(btn) btn.classList.toggle("lz-var-owned", owned); } }
  function isCardFullyOwned(li) { if(!li.classList.contains("lz-owned")) return false; for(const b of li.querySelectorAll(".lz-var-toggle-owned")) { const k=b.dataset.kind; if(k!=="normal" && k!=="holo" && b.dataset.owned!=="true") return false; } return true; }
  function syncFullyOwnedUI(li) { li.classList.toggle("lz-fully-owned", isCardFullyOwned(li)); }

  allItems.forEach(li => {
    li.querySelectorAll(".rzc-var-form").forEach(f => {
      const id = parseInt(f.querySelector('input[name="id"]')?.value, 10);
      if(id) { const p=f.querySelector(".rzc-var-price")?.textContent.replace(/[^\d,\.]/g,"").replace(",","."); if(p) variantPrices.set(id, parseFloat(p)); variantToItem.set(id, li); }
    });
  });

  // =======================================================
  // PILLS
  // =======================================================
  const bulkPills = Array.from(root.querySelectorAll(".rzc-bulk"));
  bulkPills.forEach(p => p._fullIds = (p.dataset.ids||"").split(",").map(Number).filter(n=>n));

  function recomputeBulkPills() {
    bulkPills.forEach(pill => {
      const allIds = pill._fullIds || [];
      const missingIds = allIds.filter(id => {
        const li = variantToItem.get(id);
        if(!li) return true;
        if(pill.classList.contains("is-reverse")) return !li.querySelector('.lz-var-toggle-owned[data-kind="reverse"][data-owned="true"]');
        if (pill.classList.contains("is-all")) {
          const k = getVariantKindForId(li, id);

          // ✅ toute variante non-normal (reverse, ball, cosmos, etc.)
          // doit être possédée individuellement
          if (k !== "normal") {
            return !li.querySelector(`.lz-var-toggle-owned[data-variant-id="${id}"][data-owned="true"]`);
          }

          // ✅ normal = possession via lz-owned (toggle primaire)
          return !li.classList.contains("lz-owned");
        }

        return !li.classList.contains("lz-owned");
      });
      if(!missingIds.length) { pill.style.display="none"; pill.classList.remove("is-open"); removeControls(pill); }
      else {
        pill.style.display=""; pill.dataset.ids = missingIds.join(",");
        const tot = missingIds.reduce((s,i) => s + (variantPrices.get(i)||0), 0);
        const meta = pill.querySelector(".rzc-bulk-meta");
        if(meta) meta.textContent = `${missingIds.length} Cartes • ${tot.toFixed(2).replace(".",",")}€`;
      }
    });
  }

  function injectControls(pill) {
      if(pill.querySelector(".rzc-controls")) return;
      const d = document.createElement("div"); d.className = "rzc-controls";
      d.innerHTML = `<button type="button" class="rzc-ctrl" data-action="cart">Panier</button><button type="button" class="rzc-ctrl" data-action="filter">Filtrer</button>`;
      pill.appendChild(d);
  }
  function removeControls(pill) {
      const d = pill.querySelector(".rzc-controls");
      if(d) d.remove();
  }
  function applyFilterForPill(pill) {
      const ids = new Set((pill.dataset.ids||"").split(",").map(Number));
      allItems.forEach(li => {
        let match = false;
        li.querySelectorAll('input[name="id"]').forEach(inp => { if(ids.has(parseInt(inp.value))) match=true; });
        li.classList.toggle("is-filter-pill", !match);
      });
      filterPill = pill;
      updateFilterModes();
  }

  // =======================================================
  // STATS
  // =======================================================
  const fabProgress = document.getElementById("lz-fab-progress");
  const totalReverse = parseInt(fabProgress?.dataset.countReverse || 0, 10);

  function computeCollectionStats() {
    const total = allItems.length;
    let owned = 0, avail = 0;
    allItems.forEach(li => { if(li.classList.contains("lz-owned")) owned++; else if(li.querySelector(".rzc-var-btn:not(.is-disabled)")) avail++; });
    return { total, owned, avail, pct: total?Math.round((owned/total)*100):0, pot: total?Math.round(((owned+avail)/total)*100):0 };
  }

  function computeReverseStats() {
    let owned=0, avail=0;
    allItems.forEach(li => {
      const revs = Array.from(li.querySelectorAll('.lz-var-toggle-owned[data-kind="reverse"]'));
      if(revs.length) {
        const isOwned = revs.some(r=>r.dataset.owned==="true");
        if(isOwned) owned++;
        else {
          const isAvail = revs.some(r => {
            const vid = r.dataset.variantId;
            const btn = li.querySelector(`.rzc-var-form input[value="${vid}"]`)?.closest("form")?.querySelector(".rzc-var-btn");
            return btn && !btn.classList.contains("is-disabled");
          });
          if(isAvail) avail++;
        }
      }
    });
    const total = allItems.filter(li =>
      li.querySelector('.lz-var-toggle-owned[data-kind="reverse"]')
    ).length;

    return {
      total,
      owned,
      pct: total ? Math.round((owned / total) * 100) : 0,
      pot: total ? Math.round(((owned + avail) / total) * 100) : 0
    };
  }

  function renderCollectionStats(stats) {
    const g = stats || computeCollectionStats();
    const wrap = fabProgress;
    if(!wrap) return;

    const target = wrap.querySelector('.lz-collection-progress-inner:not(.lz-collection-progress-inner-reverse)');
    if(!target) return;

    target.querySelector(".lz-collection-progress-count").textContent = `${g.owned} / ${g.total}`;
    target.querySelector(".lz-collection-progress-percent").textContent = `${g.pct}%`;
    target.querySelector(".lz-collection-progress-fill").style.width = `${g.pct}%`;
    const dispo = root.querySelector(".lz-available-switch")?.dataset.on === "1";
    target.querySelector(".lz-collection-progress-fill-available").style.width = dispo ? `${g.pot}%` : "0%";
  }

  function renderReverseStats(stats) {
    const r = stats || computeReverseStats();
    const wrap = fabProgress;
    if(!wrap) return;

    const target = wrap.querySelector(".lz-collection-progress-inner-reverse");
    if(!target) return;

    target.querySelector(".lz-collection-progress-count-reverse").textContent = `${r.owned} / ${r.total}`;
    target.querySelector(".lz-collection-progress-percent-reverse").textContent = `${r.pct}%`;
    target.querySelector(".lz-collection-progress-fill-reverse").style.width = `${r.pct}%`;
    const dispo = root.querySelector(".lz-available-switch")?.dataset.on === "1";
    target.querySelector(".lz-collection-progress-fill-available-reverse").style.width = dispo ? `${r.pot}%` : "0%";
  }

  function updateAllStats() {
    const g = computeCollectionStats();
    const r = computeReverseStats();

    renderCollectionStats(g); 
    renderReverseStats(r);
    recomputeBulkPills(); 
    updateFilterModes();

    syncSeriesProgressToSupabase(g, r);
  }
  
  function updateFilterModes() {
    const missing = root.querySelector(".lz-missing-switch")?.dataset.on === "1";
    const avail = root.querySelector(".lz-available-switch")?.dataset.on === "1";
    collectionItems.forEach(li => {
        let hide = li.classList.contains("is-filter-pill");
        if(missing && isCardFullyOwned(li)) hide = true;
        if(avail && !li.querySelector(".rzc-var-btn:not(.is-disabled)")) hide = true;
        li.classList.toggle("is-filter-mode", hide);
    });
    root.classList.toggle("has-filter", allItems.some(li => li.classList.contains("is-filter-mode")));
  } 

    // ================================
  // LZ — Profil FAB : si pas loggé => login
  // ================================
  const profileBtn = document.querySelector(".lz-profile-btn");
  if (profileBtn) {
    profileBtn.addEventListener("click", (ev) => {
      if (!isLoggedIn) { 
        ev.preventDefault();
        showToast("Connecte-toi !");
        window.location.href = loginUrl;
      } 
    });
  }

  // =======================================================
  // FAB OPEN/CLOSE helper (sans toast)
  // =======================================================
  const fabProgressPanel = document.getElementById("lz-fab-progress");
  function setFabOpen(isOpen){
    root.classList.toggle("lz-fab-open", !!isOpen);
    if (fabProgressPanel){
      fabProgressPanel.setAttribute("aria-hidden", isOpen ? "false" : "true");
    }
    if (isOpen) root.classList.remove("lz-filter-open");
    if (window.innerWidth < 768) {
      const crisp = document.querySelector(".crisp-client");
      if (crisp) crisp.style.display = isOpen ? "none" : "";
    }
  }

  // =======================================================
  // FAB TRIGGER (bind une seule fois)
  // =======================================================
  const fabTrigger = document.getElementById("lz-fab-trigger");
  if (fabTrigger) {
    fabTrigger.addEventListener("click", (ev) => {
      ev.preventDefault();
      ev.stopPropagation();

      if (!isLoggedIn) {
        showToast("Connecte-toi !");
        window.location.href = loginUrl;
        return;
      }

      const menuOpen = root.classList.contains("lz-fab-open");
      setFabOpen(!menuOpen); // ✅ toggle normal

      updateAllStats();
    });
  }

  const fabClose = document.getElementById("lz-fab-close");
  if (fabClose) {
    fabClose.addEventListener("click", (ev) => {
      ev.preventDefault();
      setFabOpen(false);
    });
  }

  // =======================================================
  // PANEL FILTRES (port OP/Lorcana)
  // =======================================================
  const filterTrigger = document.getElementById("lz-filter-trigger");
  const filterClose = document.getElementById("lz-filter-close");
  const filterReset = document.getElementById("lz-filter-reset");
  const filterPills = root.querySelectorAll(".lz-filter-pill");

  function setFilterOpen(isOpen) {
    root.classList.toggle("lz-filter-open", !!isOpen);
    const panel = document.getElementById("lz-filter-panel");
    if (panel) panel.setAttribute("aria-hidden", isOpen ? "false" : "true");
    if (isOpen) setFabOpen(false);
  }

  if (filterTrigger) {
    filterTrigger.addEventListener("click", (ev) => {
      ev.preventDefault();
      setFilterOpen(!root.classList.contains("lz-filter-open"));
    });
  }

  if (filterClose) {
    filterClose.addEventListener("click", (ev) => {
      ev.preventDefault();
      setFilterOpen(false);
    });
  }

  const FILTER_TYPES = ["rarete", "type", "fonction", "stade", "regulation"];

  function applyFilters() {
    const active = {};
    root.querySelectorAll(".lz-filter-pill").forEach((pill) => {
      if (pill.getAttribute("aria-pressed") === "true") {
        const t = pill.dataset.filterType;
        if (!active[t]) active[t] = [];
        active[t].push(pill.dataset.filterValue);
      }
    });

    const types = Object.keys(active);
    const items = root.querySelectorAll(".rzc-item");

    items.forEach((item) => {
      if (types.length === 0) {
        item.classList.remove("lz-filter-hidden");
        return;
      }

      let visible = true;
      for (const t of types) {
        const val = (item.dataset[t] || "").toLowerCase();
        const vals = val.split(",").map((v) => v.trim());
        const match = active[t].some((f) => vals.includes(f));
        if (!match) { visible = false; break; }
      }

      item.classList.toggle("lz-filter-hidden", !visible);
    });

    FILTER_TYPES.forEach((t) => {
      const count = (active[t] || []).length;
      const badge = root.querySelector('.lz-filter-count[data-filter-section="' + t + '"]');
      if (badge) {
        badge.textContent = count;
        badge.classList.toggle("is-active", count > 0);
      }
    });
  }

  function syncFiltersToUrl() {
    const params = new URLSearchParams(window.location.search);
    FILTER_TYPES.forEach((t) => params.delete(t));
    const active = {};
    root.querySelectorAll(".lz-filter-pill").forEach((pill) => {
      if (pill.getAttribute("aria-pressed") === "true") {
        const t = pill.dataset.filterType;
        if (!active[t]) active[t] = [];
        active[t].push(pill.dataset.filterValue);
      }
    });
    Object.entries(active).forEach(([t, vals]) => params.set(t, vals.join(",")));
    const qs = params.toString();
    const url = window.location.pathname + (qs ? "?" + qs : "");
    history.replaceState(null, "", url);
  }

  function restoreFiltersFromUrl() {
    const params = new URLSearchParams(window.location.search);
    let hasFilters = false;
    FILTER_TYPES.forEach((t) => {
      const val = params.get(t);
      if (!val) return;
      const vals = val.split(",").map((v) => v.trim());
      root.querySelectorAll(".lz-filter-pill").forEach((pill) => {
        if (pill.dataset.filterType === t && vals.includes(pill.dataset.filterValue)) {
          pill.setAttribute("aria-pressed", "true");
          hasFilters = true;
        }
      });
    });
    if (hasFilters) {
      applyFilters();
      setFilterOpen(true);
    }
  }

  filterPills.forEach((pill) => {
    pill.addEventListener("click", () => {
      const pressed = pill.getAttribute("aria-pressed") === "true";
      pill.setAttribute("aria-pressed", pressed ? "false" : "true");
      applyFilters();
      syncFiltersToUrl();
    });
  });

  if (filterReset) {
    filterReset.addEventListener("click", () => {
      root.querySelectorAll(".lz-filter-pill").forEach((p) => p.setAttribute("aria-pressed", "false"));
      applyFilters();
      syncFiltersToUrl();
    });
  }

  restoreFiltersFromUrl();

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && root.classList.contains("lz-filter-open")) {
      setFilterOpen(false);
    }
  });

  // =======================================================
  // SYNC TOGGLES FAB / BASE
  // =======================================================
  function syncFabTogglesFromPanel() {
      const fabSwitches = root.querySelectorAll(".lz-fab-switch");
      const baseSwitches = {
          collection: root.querySelector(".lz-collection-switch:not(.lz-fab-switch)"),
          available: root.querySelector(".lz-available-switch:not(.lz-fab-switch)"),
          missing: root.querySelector(".lz-missing-switch:not(.lz-fab-switch)"),
      };

      fabSwitches.forEach(fabSw => {
          const controlType = fabSw.dataset.control;
          const baseSw = baseSwitches[controlType];
          if (baseSw) {
              const isOn = baseSw.dataset.on === "1";
              fabSw.dataset.on = isOn ? "1" : "0";
              fabSw.classList.toggle("is-on", isOn);
              fabSw.closest(".lz-fab-bar-group")?.classList.toggle("is-on", isOn);
          }
      });
  }

// =======================================================
  // DETAILS TOGGLE
  // =======================================================
  const detailsToggle = root.querySelector('.lz-masterset-toggle-details');
  const detailsDiv = document.getElementById('lz-masterset-details');
  if(detailsToggle && detailsDiv) {
      detailsToggle.addEventListener('click', () => {
          const isHidden = detailsDiv.hidden;
          detailsDiv.hidden = !isHidden;
          // MODIFICATION ICI : Suppression des flèches
          detailsToggle.textContent = isHidden ? "Masquer le détail" : "Voir le détail"; 
      });
  }

  // =======================================================
  // EVENTS
  // =======================================================
  root.addEventListener("click", async (e) => {

    const disabledBtn = e.target.closest(".rzc-var-btn.is-disabled");
    if (disabledBtn) {
        e.preventDefault();
        e.stopPropagation();
        showToast("❌ Non Disponible", true);
        return;
    }

    const ctrl = e.target.closest(".rzc-ctrl");
    if(ctrl) {
        e.stopPropagation();
        const pill = ctrl.closest(".rzc-bulk");
        if(ctrl.dataset.action === "cart") {
            const ids = (pill.dataset.ids||"").split(",").map(Number).filter(n=>n);
            pill.dataset.loading="1";
            pill.insertAdjacentHTML('beforeend', `<div class="rzc-progress-text" style="grid-column:span 2;text-align:center;font-size:11px;">Ajout...</div>`);
            try {
              for(let i=0; i<ids.length; i+=25) await addBatch(ids.slice(i,i+25).map(id=>({id, quantity:1})));
              showToast(`➕ ${ids.length} ajoutés`); await refreshCartCount();
            } catch(e){ showToast("Erreur", true); }
            finally {
                pill.dataset.loading="0";
                pill.classList.remove("is-open");
                removeControls(pill);
                pill.querySelector(".rzc-progress-text")?.remove();
                recomputeBulkPills();
            }
        } else if(ctrl.dataset.action === "filter") {
            if(filterPill && filterPill!==pill) { filterPill.dataset.filtering="0"; allItems.forEach(li=>li.classList.remove("is-filter-pill")); }
            const on = pill.dataset.filtering==="1";
            pill.dataset.filtering = on ? "0" : "1";
            if(on) allItems.forEach(li=>li.classList.remove("is-filter-pill")); else applyFilterForPill(pill);
            updateFilterModes();
        }
        return;
    }

    const pill = e.target.closest(".rzc-bulk");
    if(pill && pill.dataset.loading!=="1") {
        const isOpen = pill.classList.contains("is-open");
        root.querySelectorAll(".rzc-bulk.is-open").forEach(o => { o.classList.remove("is-open"); removeControls(o); });
        if(!isOpen) { pill.classList.add("is-open"); injectControls(pill); }
    }

    const sw = e.target.closest(".lz-collection-switch, .lz-missing-switch, .lz-available-switch");
    if(sw) {
        const isFabSwitch = sw.classList.contains("lz-fab-switch");

        if(!isLoggedIn) { showToast("Connecte-toi !"); window.location.href=loginUrl; return; }

        const on = sw.dataset.on==="1"; 
        const newState = !on;

        let controlType = sw.dataset.control;

        if (sw.classList.contains("lz-collection-switch")) controlType = 'collection';
        else if (sw.classList.contains("lz-available-switch")) controlType = 'available';
        else if (sw.classList.contains("lz-missing-switch")) controlType = 'missing';

        const baseSwitch = root.querySelector(`.${controlType}-switch:not(.lz-fab-switch)`);
        if (baseSwitch) {
            baseSwitch.dataset.on = newState ? "1" : "0";
            baseSwitch.classList.toggle("is-on", newState);
            baseSwitch.setAttribute("aria-pressed", newState);
        }

        const fabSwitch = root.querySelector(`.lz-fab-switch[data-control="${controlType}"]`);
        if (fabSwitch) {
            fabSwitch.dataset.on = newState ? "1" : "0";
            fabSwitch.classList.toggle("is-on", newState);
            fabSwitch.closest(".lz-fab-bar-group")?.classList.toggle("is-on", newState);
        }

        if(controlType === "collection") {
            root.classList.toggle("lz-mode-collection", newState);
        }

        updateAllStats();
        return;
    }

    const tglV = e.target.closest(".lz-var-toggle-owned");
    if(tglV) {
        e.preventDefault(); e.stopPropagation();
        if(!isLoggedIn) return window.location.href=loginUrl;
        const li = tglV.closest(".rzc-item");

        const isOwned = tglV.dataset.owned === "true";
        const isConfirm = tglV.dataset.confirmRemove === "1";

        let newOwned = isOwned;

        if (!isOwned) {
            tglV.dataset.owned = "true";
            tglV.dataset.confirmRemove = "0";
            tglV.textContent = "✅";
            newOwned = true;
        } else if (isOwned && !isConfirm) {
            tglV.dataset.confirmRemove = "1";
            tglV.textContent = "➖";
            return;
        } else {
            tglV.dataset.owned = "false";
            tglV.dataset.confirmRemove = "0";
            tglV.textContent = "➕";
            newOwned = false;
        }

        const isPrimary = (tglV === getPrimaryVariantToggle(li));
        if(isPrimary) {
            li.classList.toggle("lz-owned", newOwned);
            persistOwnedState(li.dataset.productId, newOwned, li.dataset.productTitle);
        }
        persistVariantOwnedState(tglV.dataset.variantId, newOwned, li.dataset.productId, li.dataset.productTitle, tglV.dataset.kind);

        const form = tglV.closest("form");
        if(form) form.querySelector(".rzc-var-btn")?.classList.toggle("lz-var-owned", newOwned);

        updateAllStats();
        syncFullyOwnedUI(li);
    }
  });
})();

    